import React,{ useState, useEffect} from 'react';
import { TransparentButton } from '../Components/Button';
import { HeaderText1, HeaderText2 } from '../Components/Text';
import { FlexColumnContainer, FlexRowContainer } from '../Containers';
import styled from 'styled-components';
import { Colors } from '../Theme/Variable';
import Navbar1 from '../Components/Navbar1';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import {Link} from 'react-router-dom';
import ROUTES from '../Navigation/routes';

const ContainerDiv = styled.div`
    display: flex;
    flex-direction: column;
    /* margin-left: 30px; */
    /* justify-content: center;
    align-items: center; */
`
const BoxDiv = styled.div`
    /* margin:0 5px; */
    display: flex;
    flex-direction: row;
    border: 1px solid ${Colors.grey};
    /* margin-left: 30px; */
    justify-content: space-evenly;
    align-items: center;
    border-radius: 5px;
    margin-top: 40px;
`
const Div = styled.div`
    /* margin:0 20px; */
    display: flex;
    flex-direction: row;
    /* margin-left: 30px; */
    justify-content: space-evenly;
    align-items: center;
    border-radius: 5px;
    text-align: start;
`
const Header1text = styled(HeaderText1)`
    margin-left:38px;
`
const Headertext = styled(HeaderText1)`
    margin-left:-12px;
`

const Dashboard = () => {

    const[question, setQuestion] = useState([]);
    const[answer, setAnswer] = useState([]);

    useEffect(()=>{
        fetch('https://hnc-app.herokuapp.com/v1/question')
        .then(response => response.json())
        .then(data => setQuestion(data))
        .catch(error => console.log(error));

            
        fetch('https://hnc-app.herokuapp.com/v1/viewanswers')
        .then(response => response.json())
        .then(data => setAnswer(data))
        .catch(error => console.log(error));
        

    }, []);

  return (
    <Container>
        <Navbar1/>
        <ContainerDiv>
            <Row>
                    <Col sm={12} md={6} lg={6}>
                    <HeaderText2>This weeks submission</HeaderText2>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                        <Link style={{textDecoration: 'none'}} to={ROUTES.QUESTION}>
                            <TransparentButton width="200px" text='Upload Question'/>
                        </Link>
                    </Col>
            </Row>
            { question.map(details => 
            <>
            <FlexRowContainer mt='20px' justifyContent='flex-start' >
                <FlexColumnContainer justifyContent='flex-start'>
                    <HeaderText2>Question</HeaderText2>
                    <HeaderText2 color={Colors.grey}>{details.question}</HeaderText2>
                </FlexColumnContainer>
                <FlexColumnContainer ml='100px' justifyContent='flex-start'>
                    <HeaderText2>Answer</HeaderText2>
                    <HeaderText2 color={Colors.green}>{details.correct_answer}</HeaderText2>
                </FlexColumnContainer>
            </FlexRowContainer>
                
            <Table striped bordered hover>
      <thead>
        <tr>
        <th>S/n</th>
          <th>Full Name</th>
          <th>Phone</th>
          <th>Address</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
      { answer.map( (userData, key) =>
        <tr>
        <td>{key}</td>
          <td>{userData?.userID?.fullname}</td>
          <td>{userData?.userID?.phone}</td>
          <td>{userData?.userID?.address}</td>
          <td>{userData.answer}</td>
        <td>{ userData.answer == userData.correct ? 'Correct' : 'Wrong'}</td>
        </tr>
      )}
       
      </tbody>
    </Table>
           
            </>
            )}
        </ContainerDiv>
    </Container>
  )
}

export default Dashboard